import { render, staticRenderFns } from "./SpinHistoryTable.vue?vue&type=template&id=1679e47b&"
import script from "./SpinHistoryTable.vue?vue&type=script&lang=js&"
export * from "./SpinHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./SpinHistoryTable.vue?vue&type=style&index=0&id=1679e47b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports